import Image from "next/image";
import React, { useState } from "react";
import ConversationTypeContent, { conversationTypeContentInput, conversationTypeInput } from "./ConversationTypeContent";

interface ConversationTypeProps {
    title: string;
    description: string;
}

const ConversationTypes: React.FC<ConversationTypeProps> = (props) => {
    const { title, description } = props;

    const [convoType, setConvoType] = useState(conversationTypeInput[0]);

    return (
        <div className="lg:px-4 md:px-4 px-0 lg:py-12 py-0 lg:max-w-7xl w-full flex lg:flex-row flex-col items-center gap-24">
            <div className="lg:w-3/6 w-fit flex lg:flex-col flex-col lg:items-start items-center gap-8">
                <div className="flex flex-col gap-4">
                    <h3 className="text-5xl font-bold text-black text-left" style={{ fontFamily: "Degular Display" }}>
                        {title}
                    </h3>
                    <p className="text-xl font-normal text-gray-900 text-left">{description}</p>
                </div>
                <div className="flex md:gap-6 flex-col gap-5 md:flex-row">
                    {conversationTypeInput.map((conType, index) => (
                        <>
                            <button
                                key={index}
                                className={
                                    convoType === conType
                                        ? "px-6 py-3 text-base font-normal text-white bg-blue-500 border border-solid border-gray-300 rounded-3xl focus:outline-none"
                                        : "px-6 py-3 text-base font-normal text-gray-900 border border-solid border-gray-300 rounded-3xl focus:outline-none"
                                }
                                onClick={() => setConvoType(conType)}
                            >
                                {conversationTypeContentInput[conType].title}
                            </button>
                        </>
                    ))}
                </div>
                <div>
                    <ConversationTypeContent conversationType={convoType} />
                </div>
            </div>
            <div className="lg:w-3/6 w-fit lg:mx-0 mx-2 flex justify-center">
                <Image
                    width={480}
                    height={480}
                    src={conversationTypeContentInput[convoType].imageURL}
                    alt={conversationTypeContentInput[convoType].title}
                    style={{ height: "576px", width: "576px" }}
                />
            </div>
        </div>
    );
};

export default ConversationTypes;
